import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface UseBulkActionsEntryUpdateFileProps {
  entryId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

export const useBulkActionsEntryUpdateFile = ({
  entryId,
  onSuccess,
  onError,
}: UseBulkActionsEntryUpdateFileProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['bulkActionsEntryConfirm', entryId],
    mutationFn: (file: File) => {
      const payload = {
        entry: {
          file,
        }
      };

      return privateAxios.putForm(`/bulk_actions/entries/${entryId}/update_file`, payload);
    },
    onSuccess,
    onError,
  });
};
